export const noScrollClass = 'vui-no-scroll'

// Color Primitives - Split by Color Family
export const vuiColorDarkBlue = `
--vui-color-dark-blue-95: #eaeffb;
--vui-color-dark-blue-90: #d4def7;
--vui-color-dark-blue-85: #bfcef2;
--vui-color-dark-blue-80: #aabdee;
--vui-color-dark-blue-75: #95adea;
--vui-color-dark-blue-70: #7f9ce6;
--vui-color-dark-blue-65: #6a8ce2;
--vui-color-dark-blue-60: #557bdd;
--vui-color-dark-blue-55: #3f6bd9;
--vui-color-dark-blue-50: #2a5ad5;
--vui-color-dark-blue-45: #2651c0;
--vui-color-dark-blue-40: #2248aa;
--vui-color-dark-blue-35: #1d3f95;
--vui-color-dark-blue-30: #193680;
--vui-color-dark-blue-25: #152d6a;
--vui-color-dark-blue-18: #0f214d;
--vui-color-dark-blue-15: #0d1b40;
--vui-color-dark-blue-10: #08122b;
--vui-color-dark-blue-8: #070e21;
--vui-color-dark-blue-5: #040915;
`

export const vuiColorSeaBlue = `
--vui-color-sea-blue-95: #e5efff;
--vui-color-sea-blue-90: #ccdfff;
--vui-color-sea-blue-85: #b2cfff;
--vui-color-sea-blue-80: #99beff;
--vui-color-sea-blue-75: #80aeff;
--vui-color-sea-blue-70: #669eff;
--vui-color-sea-blue-65: #4d8eff;
--vui-color-sea-blue-60: #337eff;
--vui-color-sea-blue-55: #1a6eff;
--vui-color-sea-blue-50: #005eff;
--vui-color-sea-blue-45: #0054e5;
--vui-color-sea-blue-40: #004bcc;
--vui-color-sea-blue-35: #0041b2;
--vui-color-sea-blue-28: #00348f;
--vui-color-sea-blue-25: #002f80;
--vui-color-sea-blue-20: #002566;
--vui-color-sea-blue-15: #001c4d;
--vui-color-sea-blue-10: #001333;
--vui-color-sea-blue-5: #00091a;
`

export const vuiColorSkyBlue = `
--vui-color-sky-blue-97: #f2fafd;
--vui-color-sky-blue-95: #e9f7fc;
--vui-color-sky-blue-90: #d3eef8;
--vui-color-sky-blue-85: #bce6f5;
--vui-color-sky-blue-80: #a6def2;
--vui-color-sky-blue-77: #99d9f0;
--vui-color-sky-blue-65: #64c5e8;
--vui-color-sky-blue-60: #4ebce4;
--vui-color-sky-blue-55: #37b4e1;
--vui-color-sky-blue-50: #21acde;
--vui-color-sky-blue-45: #1e9ac8;
--vui-color-sky-blue-40: #1b89b1;
--vui-color-sky-blue-35: #17789b;
--vui-color-sky-blue-30: #146785;
--vui-color-sky-blue-25: #11566f;
--vui-color-sky-blue-20: #0d4559;
--vui-color-sky-blue-15: #0a3343;
--vui-color-sky-blue-10: #07222c;
--vui-color-sky-blue-5: #031116;
`

export const vuiColorDigiGreen = `
--vui-color-digi-green-95: #e5ffee;
--vui-color-digi-green-90: #ccffdc;
--vui-color-digi-green-85: #b3ffcb;
--vui-color-digi-green-80: #99ffb9;
--vui-color-digi-green-78: #8fffb2;
--vui-color-digi-green-70: #66ff96;
--vui-color-digi-green-65: #4dff85;
--vui-color-digi-green-60: #33ff74;
--vui-color-digi-green-55: #1aff62;
--vui-color-digi-green-50: #00ff51;
--vui-color-digi-green-45: #00e549;
--vui-color-digi-green-40: #00cc41;
--vui-color-digi-green-35: #00b239;
--vui-color-digi-green-30: #009930;
--vui-color-digi-green-25: #008028;
--vui-color-digi-green-20: #006620;
--vui-color-digi-green-15: #004d18;
--vui-color-digi-green-10: #003310;
--vui-color-digi-green-5: #001a08;
`

export const vuiColorSandstone = `
--vui-color-sandstone-97: #f8f7f7;
--vui-color-sandstone-95: #f3f2f2;
--vui-color-sandstone-90: #e6e6e5;
--vui-color-sandstone-85: #dad9d8;
--vui-color-sandstone-79: #cbcac8;
--vui-color-sandstone-75: #c1c0bd;
--vui-color-sandstone-70: #b5b3b0;
--vui-color-sandstone-65: #a8a7a3;
--vui-color-sandstone-60: #9c9a96;
--vui-color-sandstone-55: #908d89;
--vui-color-sandstone-50: #83817c;
--vui-color-sandstone-45: #76746f;
--vui-color-sandstone-40: #696763;
--vui-color-sandstone-35: #5c5a57;
--vui-color-sandstone-30: #4f4d4a;
--vui-color-sandstone-25: #42403e;
--vui-color-sandstone-20: #353431;
--vui-color-sandstone-15: #272725;
--vui-color-sandstone-12: #212120;
--vui-color-sandstone-10: #1a1a19;
--vui-color-sandstone-5: #0d0d0c;
`

export const vuiColorWarmGrey = `
--vui-color-warm-grey-95: #f3f2f1;
--vui-color-warm-grey-90: #e8e5e3;
--vui-color-warm-grey-85: #dcd9d6;
--vui-color-warm-grey-80: #d0ccc8;
--vui-color-warm-grey-75: #c4bfba;
--vui-color-warm-grey-70: #b9b2ac;
--vui-color-warm-grey-65: #ada69f;
--vui-color-warm-grey-60: #a19991;
--vui-color-warm-grey-56: #988f86;
--vui-color-warm-grey-50: #8a8075;
--vui-color-warm-grey-45: #7c736a;
--vui-color-warm-grey-40: #6e665e;
--vui-color-warm-grey-35: #605952;
--vui-color-warm-grey-30: #534d46;
--vui-color-warm-grey-25: #45403b;
--vui-color-warm-grey-20: #37332f;
--vui-color-warm-grey-15: #292623;
--vui-color-warm-grey-10: #1c1a17;
--vui-color-warm-grey-5: #0e0d0c;
`

export const vuiColorEarth = `
--vui-color-earth-97: #fbf8f3;
--vui-color-earth-95: #f9f3eb;
--vui-color-earth-89: #f2e5d4;
--vui-color-earth-85: #eddcc4;
--vui-color-earth-80: #e7d1b1;
--vui-color-earth-75: #e1c59d;
--vui-color-earth-70: #dbb98a;
--vui-color-earth-65: #d5ae76;
--vui-color-earth-60: #cfa263;
--vui-color-earth-55: #c9964f;
--vui-color-earth-50: #c38b3c;
--vui-color-earth-45: #b07d36;
--vui-color-earth-40: #9c6f30;
--vui-color-earth-35: #89612a;
--vui-color-earth-30: #755324;
--vui-color-earth-25: #62451e;
--vui-color-earth-20: #4e3818;
--vui-color-earth-15: #3b2a12;
--vui-color-earth-10: #271c0c;
--vui-color-earth-5: #140e06;
`

export const vuiColorPine = `
--vui-color-pine-95: #ecf5f8;
--vui-color-pine-90: #daebf1;
--vui-color-pine-85: #c7e2ea;
--vui-color-pine-80: #b5d8e3;
--vui-color-pine-75: #a2cedd;
--vui-color-pine-70: #8fc4d6;
--vui-color-pine-65: #7dbacf;
--vui-color-pine-60: #6ab0c8;
--vui-color-pine-55: #57a7c1;
--vui-color-pine-50: #459dba;
--vui-color-pine-45: #3e8da8;
--vui-color-pine-40: #377d95;
--vui-color-pine-35: #306e82;
--vui-color-pine-31: #2b6173;
--vui-color-pine-25: #224e5d;
--vui-color-pine-20: #1c3f4a;
--vui-color-pine-15: #152f38;
--vui-color-pine-10: #0e1f25;
--vui-color-pine-5: #071013;
`

export const vuiColorEucalyptus = `
--vui-color-eucalyptus-95: #e8fdfc;
--vui-color-eucalyptus-90: #d1faf9;
--vui-color-eucalyptus-85: #baf7f5;
--vui-color-eucalyptus-80: #a3f5f2;
--vui-color-eucalyptus-75: #8cf2ef;
--vui-color-eucalyptus-70: #75f0ec;
--vui-color-eucalyptus-65: #5eede8;
--vui-color-eucalyptus-60: #47ebe5;
--vui-color-eucalyptus-55: #30e8e2;
--vui-color-eucalyptus-50: #1ae5df;
--vui-color-eucalyptus-45: #17cfc8;
--vui-color-eucalyptus-41: #15c1bb;
--vui-color-eucalyptus-35: #12a19c;
--vui-color-eucalyptus-30: #0f8a86;
--vui-color-eucalyptus-25: #0d736f;
--vui-color-eucalyptus-20: #0a5c59;
--vui-color-eucalyptus-15: #084543;
--vui-color-eucalyptus-10: #052e2d;
--vui-color-eucalyptus-5: #031716;
`

export const vuiColorLavender = `
--vui-color-lavender-95: #ebedfa;
--vui-color-lavender-90: #d7dbf4;
--vui-color-lavender-85: #c3c8ef;
--vui-color-lavender-80: #aeb6ea;
--vui-color-lavender-77: #a2abe6;
--vui-color-lavender-70: #8692df;
--vui-color-lavender-65: #7280da;
--vui-color-lavender-60: #5e6ed4;
--vui-color-lavender-55: #4a5bcf;
--vui-color-lavender-50: #3649c9;
--vui-color-lavender-45: #3042b5;
--vui-color-lavender-40: #2b3ba1;
--vui-color-lavender-35: #25338d;
--vui-color-lavender-30: #202c79;
--vui-color-lavender-25: #1b2565;
--vui-color-lavender-20: #151d51;
--vui-color-lavender-15: #10163c;
--vui-color-lavender-10: #0b0f28;
--vui-color-lavender-5: #050714;
`

export const vuiColorTerracotta = `
--vui-color-terracotta-95: #fff4e5;
--vui-color-terracotta-90: #ffe9cc;
--vui-color-terracotta-85: #ffdeb3;
--vui-color-terracotta-80: #ffd399;
--vui-color-terracotta-75: #ffc880;
--vui-color-terracotta-70: #ffbd66;
--vui-color-terracotta-65: #ffb24d;
--vui-color-terracotta-60: #ffa733;
--vui-color-terracotta-55: #ff9c1a;
--vui-color-terracotta-50: #ff9100;
--vui-color-terracotta-45: #e58200;
--vui-color-terracotta-40: #cc7400;
--vui-color-terracotta-35: #b26500;
--vui-color-terracotta-30: #995700;
--vui-color-terracotta-25: #804800;
--vui-color-terracotta-20: #663a00;
--vui-color-terracotta-15: #4d2b00;
--vui-color-terracotta-10: #331d00;
--vui-color-terracotta-5: #1a0e00;
`

export const vuiColorLandGreen = `
--vui-color-land-green-95: #edf8ec;
--vui-color-land-green-90: #dcf2d9;
--vui-color-land-green-85: #caebc6;
--vui-color-land-green-80: #b8e5b3;
--vui-color-land-green-75: #a6dea0;
--vui-color-land-green-70: #95d88d;
--vui-color-land-green-65: #83d17a;
--vui-color-land-green-60: #71cb67;
--vui-color-land-green-55: #5fc454;
--vui-color-land-green-50: #4ebe41;
--vui-color-land-green-45: #46ab3b;
--vui-color-land-green-41: #409c35;
--vui-color-land-green-35: #36852e;
--vui-color-land-green-30: #2f7227;
--vui-color-land-green-25: #275f21;
--vui-color-land-green-20: #1f4c1a;
--vui-color-land-green-15: #173914;
--vui-color-land-green-10: #10260d;
--vui-color-land-green-5: #081307;
`

export const vuiColorSunflower = `
--vui-color-sunflower-95: #fffde6;
--vui-color-sunflower-90: #fffbcc;
--vui-color-sunflower-85: #fff9b2;
--vui-color-sunflower-80: #fff699;
--vui-color-sunflower-73: #fff475;
--vui-color-sunflower-70: #fff166;
--vui-color-sunflower-65: #fff04d;
--vui-color-sunflower-60: #ffee33;
--vui-color-sunflower-55: #ffec1a;
--vui-color-sunflower-50: #ffea00;
--vui-color-sunflower-45: #e5d200;
--vui-color-sunflower-40: #ccbb00;
--vui-color-sunflower-35: #b2a400;
--vui-color-sunflower-30: #998b00;
--vui-color-sunflower-25: #807500;
--vui-color-sunflower-20: #665e00;
--vui-color-sunflower-15: #4d4600;
--vui-color-sunflower-10: #332f00;
--vui-color-sunflower-5: #1a1700;
`

export const vuiColorEnergyRed = `
--vui-color-energy-red-95: #fde8e9;
--vui-color-energy-red-90: #fbd0d2;
--vui-color-energy-red-85: #f8b9bc;
--vui-color-energy-red-80: #f6a2a6;
--vui-color-energy-red-75: #f48a90;
--vui-color-energy-red-70: #f27379;
--vui-color-energy-red-65: #f05c63;
--vui-color-energy-red-60: #ee444d;
--vui-color-energy-red-54: #eb2832;
--vui-color-energy-red-50: #e91620;
--vui-color-energy-red-45: #d2141d;
--vui-color-energy-red-40: #bb111a;
--vui-color-energy-red-35: #a30f17;
--vui-color-energy-red-30: #8c0d13;
--vui-color-energy-red-25: #750b10;
--vui-color-energy-red-20: #5d090d;
--vui-color-energy-red-15: #46070a;
--vui-color-energy-red-10: #2f0406;
--vui-color-energy-red-5: #170203;
`

export const vuiColorCyan = `
--vui-color-cyan-95: #e5f8ff;
--vui-color-cyan-60: #33c8ff;
--vui-color-cyan-43: #009fda;
`

export const vuiColorOpacityDark = `
--vui-color-opacity-dark-0: #00000000;
--vui-color-opacity-dark-5: #0000000d;
--vui-color-opacity-dark-10: #0000001a;
--vui-color-opacity-dark-15: #00000026;
--vui-color-opacity-dark-20: #00000033;
--vui-color-opacity-dark-25: #00000040;
--vui-color-opacity-dark-30: #0000004d;
--vui-color-opacity-dark-35: #00000059;
--vui-color-opacity-dark-40: #00000066;
--vui-color-opacity-dark-45: #00000073;
--vui-color-opacity-dark-50: #00000080;
--vui-color-opacity-dark-55: #0000008c;
--vui-color-opacity-dark-60: #00000099;
--vui-color-opacity-dark-65: #000000a6;
--vui-color-opacity-dark-70: #000000b2;
--vui-color-opacity-dark-75: #000000bf;
--vui-color-opacity-dark-80: #000000cc;
--vui-color-opacity-dark-85: #000000d9;
--vui-color-opacity-dark-90: #000000e5;
--vui-color-opacity-dark-95: #000000f2;
`

export const vuiColorOpacityLight = `
--vui-color-opacity-light-0: #ffffff00;
--vui-color-opacity-light-5: #ffffff0d;
--vui-color-opacity-light-10: #ffffff1a;
--vui-color-opacity-light-15: #ffffff26;
--vui-color-opacity-light-20: #ffffff33;
--vui-color-opacity-light-25: #ffffff40;
--vui-color-opacity-light-30: #ffffff4d;
--vui-color-opacity-light-35: #ffffff59;
--vui-color-opacity-light-40: #ffffff66;
--vui-color-opacity-light-45: #ffffff73;
--vui-color-opacity-light-50: #ffffff80;
--vui-color-opacity-light-55: #ffffff8c;
--vui-color-opacity-light-60: #ffffff99;
--vui-color-opacity-light-65: #ffffffa6;
--vui-color-opacity-light-70: #ffffffb2;
--vui-color-opacity-light-75: #ffffffbf;
--vui-color-opacity-light-80: #ffffffcc;
--vui-color-opacity-light-85: #ffffffd9;
--vui-color-opacity-light-90: #ffffffe5;
--vui-color-opacity-light-95: #fffffff2;
`

export const vuiColorBase = `
--vui-color-opacity-none: #00000000;
--vui-color-black-10: #1a11101a;
--vui-color-grey: #f9f9f9;
--vui-color-white: #ffffff;
--vui-color-black: #000000;
`

export const vuiColorPrimitives = `
/* Color Primitives */
${vuiColorDarkBlue}
${vuiColorSeaBlue}
${vuiColorSkyBlue}
${vuiColorDigiGreen}
${vuiColorSandstone}
${vuiColorWarmGrey}
${vuiColorEarth}
${vuiColorPine}
${vuiColorEucalyptus}
${vuiColorLavender}
${vuiColorTerracotta}
${vuiColorLandGreen}
${vuiColorSunflower}
${vuiColorEnergyRed}
${vuiColorCyan}
${vuiColorOpacityDark}
${vuiColorOpacityLight}
${vuiColorBase}
`

// Semantic Tokens
export const vuiSemanticForeground = `
--vui-foreground-brand-primary: var(--vui-color-sea-blue-28);
--vui-foreground-brand-secondary: var(--vui-color-dark-blue-18);
--vui-foreground-contrast: var(--vui-color-digi-green-78);
--vui-foreground-default: var(--vui-color-sandstone-10);
--vui-foreground-inverse: var(--vui-color-white);
--vui-foreground-muted: var(--vui-color-warm-grey-30);
`

export const vuiSemanticBackground = `
--vui-background-cold: var(--vui-color-sky-blue-97);
--vui-background-contrast: var(--vui-color-dark-blue-18);
--vui-background-default: var(--vui-color-white);
--vui-background-elevated: var(--vui-color-white);
--vui-background-muted: var(--vui-color-sandstone-95);
--vui-background-subtle: var(--vui-color-sandstone-97);
--vui-background-warm: var(--vui-color-earth-95);
`

// Utility Tokens
export const vuiUtilityBorder = `
--vui-utility-border-brand: var(--vui-color-dark-blue-18);
--vui-utility-border-default: var(--vui-color-opacity-dark-20);
--vui-utility-border-inverse: var(--vui-color-white);
--vui-utility-border-subtle: var(--vui-color-opacity-dark-10);
`

export const vuiUtilityLoading = `
--vui-utility-loading-brand: var(--vui-color-sea-blue-28);
--vui-utility-loading-danger: var(--vui-color-energy-red-54);
--vui-utility-loading-inverse: var(--vui-color-white);
--vui-utility-loading-skeleton: var(--vui-color-opacity-dark-30);
--vui-utility-loading-success: var(--vui-color-land-green-41);
`

export const vuiUtilityMisc = `
--vui-utility-focus: var(--vui-color-cyan-43);
--vui-utility-indicator: var(--vui-data-cyan);
--vui-utility-opacity-none: var(--vui-color-opacity-light-0);
--vui-utility-overlay: var(--vui-color-opacity-dark-50);
--vui-utility-tooltip-background: var(--vui-color-dark-blue-18);
--vui-utility-tooltip-foreground: var(--vui-color-white);
`

export const vuiUtilityTokens = `
/* Utility Tokens */
${vuiUtilityBorder}
${vuiUtilityLoading}
${vuiUtilityMisc}
`

// Navigation Tokens
export const vuiNavigationForeground = `
--vui-navigation-foreground-active: var(--vui-color-sea-blue-28);
--vui-navigation-foreground-default: var(--vui-color-sandstone-10);
--vui-navigation-foreground-disabled: var(--vui-color-sandstone-55);
--vui-navigation-foreground-hover: var(--vui-color-sandstone-10);
--vui-navigation-foreground-pressed: var(--vui-color-sandstone-10);
`

export const vuiNavigationBackground = `
--vui-navigation-background-active: var(--vui-color-sky-blue-95);
--vui-navigation-background-default: var(--vui-background-elevated);
--vui-navigation-background-disabled: var(--vui-color-sandstone-95);
--vui-navigation-background-hover: var(--vui-color-sky-blue-85);
--vui-navigation-background-pressed: var(--vui-color-sky-blue-90);
`

export const vuiNavigationBorder = `
--vui-navigation-border-active: var(--vui-color-sea-blue-28);
--vui-navigation-border-default: var(--vui-color-opacity-dark-5);
--vui-navigation-border-disabled: var(--vui-color-opacity-dark-10);
--vui-navigation-border-hover: var(--vui-color-dark-blue-18);
--vui-navigation-border-pressed: var(--vui-color-sea-blue-28);
`

export const vuiNavigationTokens = `
/* Navigation Tokens */
${vuiNavigationForeground}
${vuiNavigationBackground}
${vuiNavigationBorder}
`

// Action Tokens - Split by Color Family
export const vuiActionAI = `
--vui-action-ai-solid: var(--vui-color-cyan-43);
--vui-action-ai-solid-hover: var(--vui-color-sea-blue-20);
--vui-action-ai-solid-inverse: var(--vui-color-white);
--vui-action-ai-solid-pressed: var(--vui-color-sea-blue-35);
--vui-action-ai-subtle: var(--vui-gradient-ai-1);
--vui-action-ai-subtle-hover: var(--vui-gradient-ai-1);
--vui-action-ai-subtle-inverse: var(--vui-color-dark-blue-18);
--vui-action-ai-subtle-pressed: var(--vui-gradient-ai-1);
`

export const vuiActionBlue = `
--vui-action-blue-solid: var(--vui-color-dark-blue-18);
--vui-action-blue-solid-hover: var(--vui-color-dark-blue-25);
--vui-action-blue-solid-inverse: var(--vui-color-white);
--vui-action-blue-solid-pressed: var(--vui-color-sea-blue-28);
--vui-action-blue-subtle: var(--vui-color-sky-blue-90);
--vui-action-blue-subtle-hover: var(--vui-color-sky-blue-80);
--vui-action-blue-subtle-inverse: var(--vui-color-dark-blue-18);
--vui-action-blue-subtle-pressed: var(--vui-color-sky-blue-85);
`

export const vuiActionBrand = `
--vui-action-brand-solid: var(--vui-color-sea-blue-28);
--vui-action-brand-solid-hover: var(--vui-color-sea-blue-20);
--vui-action-brand-solid-inverse: var(--vui-color-white);
--vui-action-brand-solid-pressed: var(--vui-color-sea-blue-35);
--vui-action-brand-subtle: var(--vui-color-sky-blue-95);
--vui-action-brand-subtle-hover: var(--vui-color-sky-blue-85);
--vui-action-brand-subtle-inverse: var(--vui-color-sea-blue-28);
--vui-action-brand-subtle-pressed: var(--vui-color-sky-blue-90);
`

export const vuiActionContrast = `
--vui-action-contrast-solid: var(--vui-color-digi-green-78);
--vui-action-contrast-solid-hover: var(--vui-color-digi-green-70);
--vui-action-contrast-solid-inverse: var(--vui-color-dark-blue-18);
--vui-action-contrast-solid-pressed: var(--vui-color-digi-green-85);
--vui-action-contrast-subtle: var(--vui-color-digi-green-78);
--vui-action-contrast-subtle-hover: var(--vui-color-opacity-light-25);
--vui-action-contrast-subtle-inverse: var(--vui-color-dark-blue-18);
--vui-action-contrast-subtle-pressed: var(--vui-color-opacity-light-15);
`

export const vuiActionDanger = `
--vui-action-danger-solid: var(--vui-color-energy-red-45);
--vui-action-danger-solid-hover: var(--vui-color-energy-red-35);
--vui-action-danger-solid-inverse: var(--vui-color-white);
--vui-action-danger-solid-pressed: var(--vui-color-energy-red-50);
--vui-action-danger-subtle: var(--vui-color-energy-red-95);
--vui-action-danger-subtle-hover: var(--vui-color-energy-red-85);
--vui-action-danger-subtle-inverse: var(--vui-color-energy-red-45);
--vui-action-danger-subtle-pressed: var(--vui-color-energy-red-90);
`

export const vuiActionEucalyptus = `
--vui-action-eucalyptus-solid: var(--vui-color-eucalyptus-30);
--vui-action-eucalyptus-solid-hover: var(--vui-color-eucalyptus-41);
--vui-action-eucalyptus-solid-inverse: var(--vui-color-white);
--vui-action-eucalyptus-solid-pressed: var(--vui-color-eucalyptus-35);
--vui-action-eucalyptus-subtle: var(--vui-color-eucalyptus-95);
--vui-action-eucalyptus-subtle-hover: var(--vui-color-eucalyptus-85);
--vui-action-eucalyptus-subtle-inverse: var(--vui-color-eucalyptus-20);
--vui-action-eucalyptus-subtle-pressed: var(--vui-color-eucalyptus-90);
`

export const vuiActionGrey = `
--vui-action-grey-solid: var(--vui-color-sandstone-40);
--vui-action-grey-solid-hover: var(--vui-color-sandstone-50);
--vui-action-grey-solid-inverse: var(--vui-color-white);
--vui-action-grey-solid-pressed: var(--vui-color-sandstone-45);
--vui-action-grey-subtle: var(--vui-color-sandstone-90);
--vui-action-grey-subtle-hover: var(--vui-color-sandstone-79);
--vui-action-grey-subtle-inverse: var(--vui-color-sandstone-10);
--vui-action-grey-subtle-pressed: var(--vui-color-sandstone-85);
`

export const vuiActionLavender = `
--vui-action-lavender-solid: var(--vui-color-lavender-60);
--vui-action-lavender-solid-hover: var(--vui-color-lavender-70);
--vui-action-lavender-solid-inverse: var(--vui-color-white);
--vui-action-lavender-solid-pressed: var(--vui-color-lavender-65);
--vui-action-lavender-subtle: var(--vui-color-lavender-95);
--vui-action-lavender-subtle-hover: var(--vui-color-lavender-85);
--vui-action-lavender-subtle-inverse: var(--vui-color-lavender-20);
--vui-action-lavender-subtle-pressed: var(--vui-color-lavender-90);
`

export const vuiActionSuccess = `
--vui-action-success-solid: var(--vui-color-land-green-41);
--vui-action-success-solid-hover: var(--vui-color-land-green-25);
--vui-action-success-solid-inverse: var(--vui-color-white);
--vui-action-success-solid-pressed: var(--vui-color-land-green-30);
--vui-action-success-subtle: var(--vui-color-land-green-95);
--vui-action-success-subtle-hover: var(--vui-color-land-green-85);
--vui-action-success-subtle-inverse: var(--vui-color-land-green-20);
--vui-action-success-subtle-pressed: var(--vui-color-land-green-90);
`

export const vuiActionTerracotta = `
--vui-action-terracotta-solid: var(--vui-color-terracotta-30);
--vui-action-terracotta-solid-hover: var(--vui-color-terracotta-40);
--vui-action-terracotta-solid-inverse: var(--vui-color-white);
--vui-action-terracotta-solid-pressed: var(--vui-color-terracotta-35);
--vui-action-terracotta-subtle: var(--vui-color-terracotta-90);
--vui-action-terracotta-subtle-hover: var(--vui-color-terracotta-80);
--vui-action-terracotta-subtle-inverse: var(--vui-color-terracotta-20);
--vui-action-terracotta-subtle-pressed: var(--vui-color-terracotta-85);
`

export const vuiActionYellow = `
--vui-action-yellow-solid: var(--vui-color-sunflower-60);
--vui-action-yellow-solid-hover: var(--vui-color-sunflower-80);
--vui-action-yellow-solid-inverse: var(--vui-color-sunflower-15);
--vui-action-yellow-solid-pressed: var(--vui-color-sunflower-70);
--vui-action-yellow-subtle: var(--vui-color-sunflower-85);
--vui-action-yellow-subtle-hover: var(--vui-color-sunflower-73);
--vui-action-yellow-subtle-inverse: var(--vui-color-sunflower-15);
--vui-action-yellow-subtle-pressed: var(--vui-color-sunflower-80);
`

export const vuiActionGeneric = `
--vui-action-disabled-background: var(--vui-color-sandstone-90);
--vui-action-disabled-foreground: var(--vui-color-sandstone-70);
--vui-action-generic-hover: var(--vui-color-opacity-dark-20);
--vui-action-generic-pressed: var(--vui-color-opacity-dark-15);
`

export const vuiActionTokens = `
/* Action Tokens */
${vuiActionAI}
${vuiActionBlue}
${vuiActionBrand}
${vuiActionContrast}
${vuiActionDanger}
${vuiActionEucalyptus}
${vuiActionGrey}
${vuiActionLavender}
${vuiActionSuccess}
${vuiActionTerracotta}
${vuiActionYellow}
${vuiActionGeneric}
`

// Control Tokens
export const vuiControlTokens = `
/* Control Tokens */
--vui-control-background-default: var(--vui-color-white);
--vui-control-background-disabled: var(--vui-color-sandstone-70);
--vui-control-background-off: var(--vui-color-sandstone-50);
--vui-control-background-on: var(--vui-color-dark-blue-18);
--vui-control-border-default: var(--vui-color-sandstone-70);
--vui-control-border-hover: var(--vui-color-sandstone-10);
--vui-control-foreground-default: var(--vui-color-sandstone-10);
--vui-control-foreground-disabled: var(--vui-color-sandstone-20);
--vui-control-foreground-off: var(--vui-color-white);
--vui-control-foreground-on: var(--vui-color-white);
--vui-control-helper: var(--vui-color-sandstone-35);
--vui-control-label: var(--vui-color-sandstone-10);
--vui-control-placeholder: var(--vui-color-sandstone-60);
`

// Feedback Tokens
export const vuiFeedbackTokens = `
/* Feedback Tokens */
--vui-feedback-danger-solid: var(--vui-color-energy-red-54);
--vui-feedback-danger-subtle: var(--vui-color-energy-red-95);
--vui-feedback-info-solid: var(--vui-color-sea-blue-28);
--vui-feedback-info-subtle: var(--vui-color-sky-blue-95);
--vui-feedback-neutral-solid: var(--vui-color-warm-grey-50);
--vui-feedback-neutral-subtle: var(--vui-color-warm-grey-90);
--vui-feedback-success-solid: var(--vui-color-land-green-35);
--vui-feedback-success-subtle: var(--vui-color-land-green-95);
--vui-feedback-warning-solid: var(--vui-color-sunflower-20);
--vui-feedback-warning-subtle: var(--vui-color-sunflower-90);
`

// Data Visualization Tokens
export const vuiDataTokens = `
/* Data Visualization Tokens */
--vui-data-black: var(--vui-color-black);
--vui-data-cyan: var(--vui-color-cyan-43);
--vui-data-darkblue: var(--vui-color-dark-blue-18);
--vui-data-earth: var(--vui-color-earth-75);
--vui-data-eucalyptus: var(--vui-color-eucalyptus-41);
--vui-data-landgreen: var(--vui-color-land-green-41);
--vui-data-lavender: var(--vui-color-lavender-77);
--vui-data-orange: var(--vui-color-terracotta-50);
--vui-data-pine: var(--vui-color-pine-31);
--vui-data-red: var(--vui-color-energy-red-54);
--vui-data-skyblue: var(--vui-color-sky-blue-77);
--vui-data-sunflower: var(--vui-color-sunflower-73);
--vui-data-terracotta: var(--vui-color-terracotta-30);
--vui-data-warmgrey: var(--vui-color-warm-grey-56);
--vui-data-white: var(--vui-color-white);
`

// Gradient Tokens
export const vuiGradientTokens = `
/* Gradient Tokens */
--vui-gradient-ai-1: var(--vui-color-sky-blue-95);
--vui-gradient-ai-2: var(--vui-color-digi-green-95);
--vui-gradient-brand-1: var(--vui-color-sky-blue-80);
--vui-gradient-brand-2: var(--vui-color-sky-blue-95);
--vui-gradient-brand-3: var(--vui-color-digi-green-90);
--vui-gradient-motion-1: var(--vui-color-sky-blue-90);
--vui-gradient-motion-2: var(--vui-color-digi-green-90);
--vui-gradient-motion-3: var(--vui-color-sea-blue-90);
--vui-gradient-motion-4: var(--vui-color-eucalyptus-80);
`

// Combined Exports for Backward Compatibility
export const vuiColorSemantics = `
/* Color Semantics */
${vuiSemanticForeground}
${vuiSemanticBackground}
`

// Typography Tokens
export const vuiTypographyTokens = `
/* Typography Tokens */
--vui-label-font-weight: 600;
--vui-label-line-height: 135%;

--vui-input-font-weight: 400;
--vui-input-line-height: 135%;

--vui-caption-font-weight: 400;
--vui-caption-font-weight-bold: 600;
--vui-caption-line-height: 150%;

--vui-navigation-font-weight: 400;
--vui-navigation-line-height: 125%;

--vui-caps-text-transform: uppercase;
--vui-caps-font-weight: 600;
--vui-caps-line-height: 125%;

--vui-button-font-weight: 500;
--vui-button-line-height: 100%;

--vui-font-size-xs: 12px;
--vui-font-size-sm: 14px;
--vui-font-size-md: 16px;
--vui-font-size-lg: 18px;
--vui-font-size-xl: 20px;
`

// All Design Tokens Combined
export const vuiNextAllTokens = `
${vuiColorPrimitives}
${vuiColorSemantics}
${vuiUtilityTokens}
${vuiNavigationTokens}
${vuiActionTokens}
${vuiControlTokens}
${vuiFeedbackTokens}
${vuiDataTokens}
${vuiGradientTokens}
${vuiTypographyTokens}
`
